import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";


export default function BadgesEditor(props: any) {
  const { open, setOpen, loadList, badge_id } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    badge_id: badge_id ? badge_id : null,
    badge: '',
  };

  const [formValues, setFormValues] = useState(defaultValues);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (badge_id) {
        ApiRequest({
            url: '/badges/details',
            method: 'GET',
            query: {
                badge_id: badge_id
            },
            setResponse: (response: any) => {
                setFormValues(response.data);
            }
        });

      } else {
        setFormValues(defaultValues);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, badge_id]);

  const isFormValid = () => {
    return (
        formValues.badge !== ''
    );
  };

  const handleSubmit = async () => { 
    setLoading(true);

    await ApiRequest({
        url: "/badges/create",
        method: 'POST',
        body: formValues,
        setResponse: (response: any) => {
            if (response.status === "success") {
                enqueueSnackbar(badge_id ? 'Distintivo actualizado correctamente' : 'Distintivo creado correctamente', { variant: 'success' });
                setOpen(false);
                loadList();
                setFormValues(defaultValues);
            } else {
                enqueueSnackbar(response.message, { variant: 'error' });
            }
        }
    });

    setLoading(false);
  };

  const handleClose = () => {
    setFormValues(defaultValues);
    setOpen(false);
  };

  console.log(formValues);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <div className="DialogContainer" >
        <div className="ModuleWrapper">
            <h2>Añadir distintivo</h2>
          
          <div className="input_group">
            <TextField
              label="Distintivo"
              variant="outlined"
              fullWidth
              value={formValues.badge}
              onChange={(e) => setFormValues({ ...formValues, badge: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className="dialogButtons">
            <Button onClick={handleClose} variant="outlined">Cancelar</Button>
            <Button onClick={handleSubmit} variant="contained" disabled={!isFormValid() || loading}>
              {badge_id ? 'Actualizar distintivo' : 'Crear distintivo'}
            </Button>
          </div>
      
    </Dialog>
  );
}

